import React, { Component } from 'react'
import styled from 'styled-components'

const _SkipButton = ({ className, width, height, ...rest }) => {
  return (
    <svg className={className} width={width} height={height} {...rest} viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <path fill="#f1f1f1" d="M12,0V6.91C7.73,4.47,4,2.34,0,0V14L12,7v7h3V0Z"/>
    </svg>
  )
}

const SkipButton = styled(_SkipButton)`
  ${props => props.direction == 'previous' && `
    transform: rotateZ(180deg);
  `}
`

export default SkipButton



// WEBPACK FOOTER //
// ./src/components/visuals/SkipButton.js